export enum FlexGapSize {
    XSmall = 'xsmall',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum FlexJustify {
    Left = 'flex-start',
    Right = 'flex-end',
    Center = 'center',
    SpaceBetween = 'space-between',
    SpaceAround = 'space-around',
    SpaceEvenly = 'space-evenly',
}

export enum FlexAlign {
    Top = 'flex-start',
    Bottom = 'flex-end',
    Center = 'center',
    Normal = 'normal',
    Stretch = 'stretch',
}

export enum FlexDirection {
    Horizontal = 'horizontal',
    Vertical = 'vertical',
}
